var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 8.18182H10.8V1.63636C10.8 0.736364 9.99 0 9 0H7.2C6.21 0 5.4 0.736364 5.4 1.63636V8.18182H4.5C2.016 8.18182 0 10.0145 0 12.2727V18H16.2V12.2727C16.2 10.0145 14.184 8.18182 11.7 8.18182ZM7.2 1.63636H9V8.18182H7.2V1.63636ZM14.4 16.3636H12.6V13.9091C12.6 13.4591 12.195 13.0909 11.7 13.0909C11.205 13.0909 10.8 13.4591 10.8 13.9091V16.3636H9V13.9091C9 13.4591 8.595 13.0909 8.1 13.0909C7.605 13.0909 7.2 13.4591 7.2 13.9091V16.3636H5.4V13.9091C5.4 13.4591 4.995 13.0909 4.5 13.0909C4.005 13.0909 3.6 13.4591 3.6 13.9091V16.3636H1.8V12.2727C1.8 10.9227 3.015 9.81818 4.5 9.81818H11.7C13.185 9.81818 14.4 10.9227 14.4 12.2727V16.3636Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.e814fc371cdb56c264d0fc898ca17120.svg";
export { ForwardRef as ReactComponent };